import {useEffect, useRef, useState} from "react";
import useIsFocused from "hooks/useIsFocused";

const MAP_POLL_MS = 20 * 1000;
const ORDERS_POLL_MS = 30 * 1000;
const SHIFTS_POLL_MS = 30 * 1000;

export const useLiveOperationPolling = ({paused = false} = {}) => {
    const isFocused = useIsFocused();

    const [mapRecall, setMapRecall] = useState(true);
    const mapRecallRef = useRef(mapRecall);
    mapRecallRef.current = mapRecall;

    const [ordersRecall, setOrdersRecall] = useState(true);
    const ordersRecallRef = useRef(ordersRecall);
    ordersRecallRef.current = ordersRecall;

    const [shiftsRecall, setShiftsRecall] = useState(true);
    const shiftsRecallRef = useRef(shiftsRecall);
    shiftsRecallRef.current = shiftsRecall;

    useEffect(() => {
        if (!isFocused) return undefined;
        const timeout = setTimeout(() => {
            setMapRecall(!mapRecallRef.current);
        }, MAP_POLL_MS);
        return () => clearTimeout(timeout);
    }, [mapRecall, isFocused]);

    useEffect(() => {
        if (!isFocused || paused) return undefined;
        const timeout = setTimeout(() => {
            setOrdersRecall(!ordersRecallRef.current);
        }, ORDERS_POLL_MS);
        return () => clearTimeout(timeout);
    }, [ordersRecall, isFocused, paused]);

    useEffect(() => {
        if (!isFocused || paused) return undefined;
        const timeout = setTimeout(() => {
            setShiftsRecall(!shiftsRecallRef.current);
        }, SHIFTS_POLL_MS);
        return () => clearTimeout(timeout);
    }, [shiftsRecall, isFocused, paused]);

    return {mapRecall, ordersRecall, shiftsRecall};
};
